import { supabase } from '../../../services/supabase'

export type CompanySources = {
  hasNews: boolean
  hasMitigations: boolean
  hasReports: boolean
  hasSpend: boolean
}

/** Same check spend_dashboard uses before it returns hasData: false. */
export async function companyHasSpendFile(companyId: string): Promise<boolean> {
  const { data, error } = await supabase
    .from('company_spend_lines')
    .select('id')
    .eq('company_id', companyId)
    .limit(1)
  if (error) return false
  return (data?.length ?? 0) > 0
}

async function hasRow(
  table: 'supplier_news' | 'supplier_mitigation_tasks',
  companyId: string
): Promise<boolean> {
  const { data, error } = await supabase
    .from(table)
    .select('id')
    .or(`company_id.is.null,company_id.eq.${companyId}`)
    .limit(1)
  if (error) return false
  return (data?.length ?? 0) > 0
}

/** Which sources this company actually has. An empty category is not the same as a missing source. */
export async function loadCompanySources(companyId: string): Promise<CompanySources> {
  const [hasNews, hasMitigations, reports, hasSpend] = await Promise.all([
    hasRow('supplier_news', companyId),
    hasRow('supplier_mitigation_tasks', companyId),
    supabase.from('supplier_special_reports').select('id').limit(1),
    companyHasSpendFile(companyId),
  ])
  return {
    hasNews,
    hasMitigations,
    hasReports: !reports.error && (reports.data?.length ?? 0) > 0,
    hasSpend,
  }
}
